export default __webpack_public_path__ + "static/media/show.adfab39e.svg";